//Reservation
export const Reservation_App_Owner = "Reservation_App_Owner";
export const Reservation_Accounting = "Reservation_Accounting";
export const Reservation_Details = "Reservation_Details";
